module.exports = __webpack_public_path__ + "img/atlas-3.7e286e06.png";